import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import SiteHeader from "@/components/SiteHeader";
import Footer from "@/components/Footer";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (typeof window !== "undefined") window.__lenis = lenis;
  }, [lenis]);
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

export const Layout = () => {
  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="relative min-h-screen bg-cream">
        <div className="grain-overlay" aria-hidden="true" />
        <ScrollToTop />
        <SiteHeader />
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </ReactLenis>
  );
};

export default Layout;
